// extracted by mini-css-extract-plugin
export default {"price":"y6-z","onSale":"z6-z","msrpLabelPrice":"A6-z","msrpLabel":"B6-z","originalPrice":"C6-z","percentOff":"D6-z"};